import { BaseGetProvider, DataTransformationProtocol } from "@tendercuts/http";
import { EndPoint } from "@endpoint";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginServices } from "@login";
import { EdcMachine } from "@tendercuts/models/store/edc-machine";
import { Store } from "@tendercuts/models/store";

@Injectable({providedIn: "root"})
export class StoreEdcMachinesService extends BaseGetProvider<StoreEdcMachinesService>
  implements DataTransformationProtocol {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response) {
    return response.results;
  }

  get isCachable() {
    return true;
  }

  get isAuthenticatedEndpoint() {
    return false;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return Store;
  }

  get endpoint() {
    return this.endpointService.storeEdcMachines();
  }
}
